import axios from "../../utils/axiots";
const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:8080";

export const getBanners = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}cms-api/get-all-banners-details/futurevs/v4/external`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export const uploadImage = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(`${baseUrl}cms-api/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

export const saveBannerImage = async (
  place: string,
  sms: string,
  url: string
) => {
  const apiUrl = `${baseUrl}cms-api/add-banner-details/futurevs/v4/external`;

  const payload = {
    place,
    sms,
    url,
  };

  try {
    const response = await axios.post(apiUrl, payload);
    console.log("Banner saved:", response.data);
  } catch (error) {
    console.error("Error saving banner image:", error);
  }
};

export const getTotalNumberOfUsers = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}cms-api/get-no-of-players/futurevs/v4/external`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export const getUsers = async (nextPageLastUserId?: number | string) => {
  try {
    const url = nextPageLastUserId
      ? `${baseUrl}cms-api/get-all-players/futurevs/v4/external?lastUserId=${nextPageLastUserId}`
      : `${baseUrl}cms-api/get-all-players/futurevs/v4/external`;

    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const updateSmsBody = async (
  place: string,
  sms: string,
  url: string
) => {
  const apiUrl = `${baseUrl}cms-api/add-banner-details/futurevs/v4/external`;

  const payload = {
    place,
    url,
    sms,
  };

  try {
    const response = await axios.post(apiUrl, payload);
  } catch (error) {
    console.error("Error saving banner image:", error);
  }
};
